<template>
  <PageWrap>
    <Error404 :error="{ statusCode: 404 }" v-if="error" />

    <template v-else>
      <HeadSeo :data="data" />
      <HeaderOther
        :h1="data.title"
        :image="`${
          data.bg_image
            ? `/upload/image/${data.bg_image}/src.jpg`
            : '/static/image/video_bg3.jpg'
        }`"
      />
      <main>
        <UiBreadCrumbs :data="bc" v-if="bc" />
        <UiBackBtn url="/" />
        <BlockPageText :html="data.text" />
        <BlockGallery
          :name="`projects-${data.id}`"
          :data="data.gallery"
          h2="Фото/видео-галерея процесса и результата работ"
          v-if="data.gallery"
        />
        <BlockWasBecame
          v-if="data.before_image && data.after_image"
          :before="`/upload/image/${data.before_image}/before_after.jpg`"
          :after="`/upload/image/${data.after_image}/before_after.jpg`"
          title="Сравнените свет фар до и после наших работ"
        />
        <BlockZakazBtn />
        <BlockWhyWe />
        <!--BlockZakaz />
        <BlockAchievements /-->
        <BlockContact />
      </main>
    </template>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
// HeaderOther :text="data.modelTitle"
const bc = ref();
const { url } = useRoute().params;
const { data, error } = await useFetch(`/api/projects.post?url=${url}`);
if (error.value) {
  const event = useRequestEvent();
  setResponseStatus(event, 404, "Page Not Found");
} else {
  const _bc = [
    {
      title: "Проекты",
      path: "/projects",
    },
  ];
  if (data.value?.modelTitle && data.value?.modelUrl)
    _bc.push({
      title: data.value.modelTitle,
      path: "/projects/avto/" + data.value.modelUrl,
    });
  _bc.push({
    title: data.value?.title,
  });
  bc.value = _bc;
}
</script>
